// extracted by mini-css-extract-plugin
module.exports = {"info":"Sx-8lhaBhs","h-rule":"Op8oeD6vk-","hRule":"Op8oeD6vk-","logo":"_23WLidEbU-","further-resources":"_3NLrxtSoEq","furtherResources":"_3NLrxtSoEq"};
    if(module.hot) {
      // 1597843250475
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  